<template>
  <div class="fixed w-full inset-0 flex items-end justify-center bg-gray-500 bg-opacity-50 z-50" role="dialog" aria-modal="true">
    <transition name="slide-up" appear>
      <div class="bg-white rounded-lg shadow-lg w-full relative" style="height: 96vh">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleCloseDialog() {
      if (this.closeOnEsc) {
        this.$emit('close');
      }
    }
  },
};
</script>

<style scoped>
.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Dialog.vue?13965d39